<app-back-to-system-overview relativeUrl="../"></app-back-to-system-overview>
<sh-card>
  <api-call-gate [apiCall]="serviceTicketsService.getTickets">
    <ng-template #error let-error>
      <sh-text size="body-1" color="secondary">
        No tickets found
        <br />
        <b>Error {{ error.status }}</b
        ><br />
        {{ error.text }}
      </sh-text>
    </ng-template>
    <ng-template #lastSuccessfulData>
      <ng-container
        *ngTemplateOutlet="
          tickets;
          context: { $implicit: processedTickets$ | async }
        "
      ></ng-container>
    </ng-template>
  </api-call-gate>
</sh-card>

<ng-template #tickets let-tickets>
  <div style="display: flex; flex-direction: row; margin-bottom: 1rem">
    <sh-text size="header-2" color="primary">
      {{ 'label.plannedActivitiesTitle' | translate }}
    </sh-text>
    <sh-text size="body-1" color="secondary" style="text-align: right">
      <b>{{ processedTicketsCount$ | async }}</b>
      <span hide-phone> displaying</span> /
      <b>{{ totalTicketsCount$ | async }}</b>
      <span hide-phone> available</span>
    </sh-text>
  </div>
  <div class="menu">
    <ng-container *ngTemplateOutlet="filtersDesktop"></ng-container>
  </div>

  <div class="container">
    @if ((totalTicketsCount$ | async) === 0) {
      <sh-empty-state
        style="margin: auto"
        icon="search"
        label="No records found"
      ></sh-empty-state>
    }

    @if (tickets.length > 0) {
      <ng-container
        *ngTemplateOutlet="
          (screenLayoutService.desktopAny$ | async)
            ? ticketsDesktop
            : ticketsMobile;
          context: { $implicit: tickets }
        "
      ></ng-container>
    } @else {
      No tickets matched your criteria
    }
  </div>
</ng-template>

<ng-template #filtersDesktop>
  <!-- Date Range Filters -->
  @if (dateBoundsValid$.start | async) {
    <sh-datepicker
      [months]="screenLayoutService.datePickerMonths$ | async"
      no-clear
      class="filterFiled"
      label="Planned Start Date Range"
      [betterValue]="
        plannedActivitiesService.isScheduledUrl()
          ? (scheduledDateBoundsStartDates$ | async)
          : (overdueDateBoundsStartDates$ | async)
      "
      (betterCleared)="clearAndResetDateRange()"
      (betterChanged)="onDateRangeStartChanged($event.detail)"
      [min]="(dateBoundsForShui$.start | async)?.min"
      [max]="(dateBoundsForShui$.start | async)?.max"
      range
    ></sh-datepicker>
  }

  @if (dateBoundsValid$.end | async) {
    <sh-datepicker
      [months]="screenLayoutService.datePickerMonths$ | async"
      no-clear
      class="filterFiled"
      label="Planned End Date Range"
      [betterValue]="
        plannedActivitiesService.isScheduledUrl()
          ? (scheduledDateBoundsEndDates$ | async)
          : (overdueDateBoundsEndDates$ | async)
      "
      (betterCleared)="clearAndResetDateRange()"
      (betterChanged)="onDateRangeEndChanged($event.detail)"
      [min]="(dateBoundsForShui$.end | async)?.min"
      [max]="(dateBoundsForShui$.end | async)?.max"
      range
    ></sh-datepicker>
  }

  <!-- Activity Type Filter -->
  <sh-dropdown
    size="body-2"
    class="filterFiled"
    [label]="'label.typeOfActivity' | translate"
    [value]="(filters$ | async)?.ticketType"
    (value-changed)="onActivityTypeChanged($event.target.value)"
  >
    @for (ticketType of ticketTypes$ | async; track ticketType) {
      <sh-menu-item label="{{ ticketType }}"></sh-menu-item>
    }
  </sh-dropdown>

  <!-- Activity Status Filter -->
  <sh-dropdown
    size="body-2"
    class="filterFiled"
    [label]="'label.TicketstatusLN' | translate"
    [value]="(filters$ | async)?.activityStatus"
    (value-changed)="onActivityStatusChanged($event.target.value)"
  >
    @for (activity of activityStates$ | async; track activity) {
      <sh-menu-item label="{{ activity }}"></sh-menu-item>
    }
  </sh-dropdown>

  <!-- Search Term Filter -->
  <sh-search
    size="body-2"
    class="filterFiled"
    label="Search Term"
    [value]="(filters$ | async)?.searchString"
    (value-changed)="onSearchString($event.target.value)"
  ></sh-search>

  <!-- Reset Filters Button -->

  <sh-icon
    class="reset-icon"
    icon="reset"
    id="refresh"
    (click)="resetFilters()"
    (keyup.enter)="resetFilters()"
  ></sh-icon>
  <sh-text size="header-2" class="reset-filters" color="secondary"
    >Reset Filters</sh-text
  >
</ng-template>

<!-- tickets: desktop -->
<ng-template #ticketsDesktop let-tickets>
  <sh-table>
    <sh-table-row slot="header">
      <sh-table-head
        columns="6"
        (toggle)="
          onChangeSort(
            'plannedStart',
            $event.target.hasAttribute('sort-descending')
          )
        "
        >{{ 'label.plannedStart' | translate }}</sh-table-head
      >
      <sh-table-head
        columns="6"
        (toggle)="
          onChangeSort(
            'plannedEnd',
            $event.target.hasAttribute('sort-descending')
          )
        "
        >{{ 'label.plannedEnd' | translate }}</sh-table-head
      >
      <sh-table-head
        columns="6"
        (toggle)="
          onChangeSort(
            'ticketNumber',
            $event.target.hasAttribute('sort-descending')
          )
        "
        ><span>{{ 'label.ticketNumber' | translate }}</span>
      </sh-table-head>
      <sh-table-head
        columns="6"
        (toggle)="
          onChangeSort(
            'ticketType',
            $event.target.hasAttribute('sort-descending')
          )
        "
        >{{ 'label.typeOfActivity' | translate }}</sh-table-head
      >
      <sh-table-head
        columns="8"
        (toggle)="
          onChangeSort(
            'description',
            $event.target.hasAttribute('sort-descending')
          )
        "
        >{{ 'label.subject' | translate }}</sh-table-head
      >
      <sh-table-head
        columns="6"
        (toggle)="
          onChangeSort(
            'activityStatus',
            $event.target.hasAttribute('sort-descending')
          )
        "
      >
        {{ 'label.TicketstatusLN' | translate }}
      </sh-table-head>
    </sh-table-row>

    @for (ticket of tickets; track ticket; let i = $index) {
      <sh-table-row [attr.color]="ticket.statusColor">
        <sh-table-cell columns="6">
          {{ ticket.plannedStart | localizedDate }}
        </sh-table-cell>
        <sh-table-cell columns="6">
          {{ ticket.plannedEnd | localizedDate }}
        </sh-table-cell>
        <sh-table-cell columns="6" class="ticket">
          {{ ticket.ticketNumber }}
          <sh-icon
            [id]="'copyToClipboard_' + i"
            style="cursor: pointer; margin-top: 5px"
            (click)="clipboard.copyToClipboard(ticket.ticketNumber)"
            aria-label="Copy results to clipboard"
            icon="copy-results-to-clipboard"
            button
            size="s"
          ></sh-icon>
          <sh-tooltip
            label="Copy to Clipboard"
            [target]="'copyToClipboard_' + i"
            placement="top"
            variation="short"
          >
          </sh-tooltip>
        </sh-table-cell>
        <sh-table-cell columns="6">
          <sh-text [id]="'ticketType-' + i" #ticketType class="linebreak">
            {{ ticket.ticketType }}</sh-text
          >
          @if (isOverflowing(ticketType)) {
            <sh-tooltip
              label="{{ ticket.ticketType }}"
              [target]="'ticketType-' + i"
              placement="top"
              variation="short"
            ></sh-tooltip>
          }
        </sh-table-cell>
        <sh-table-cell columns="8">
          <sh-text [id]="'subject-' + i" #description class="linebreak">
            {{ ticket.description }}</sh-text
          >
          @if (isOverflowing(description)) {
            <sh-tooltip
              label="{{ ticket.description }}"
              [target]="'subject-' + i"
              placement="top"
              variation="short"
            ></sh-tooltip>
          }
        </sh-table-cell>
        <sh-table-cell columns="6">
          {{ ticket.activityStatus }}
        </sh-table-cell>
      </sh-table-row>
    }
  </sh-table>
</ng-template>

<!-- tickets: phone -->
<ng-template #ticketsMobile let-tickets>
  <div class="tickets-mobile">
    @for (ticket of tickets; track ticket) {
      <div
        id="only-planned-activities"
        class="ticket"
        [attr.color]="ticket.statusColor"
      >
        <div class="item">
          <sh-text size="body-2" color="secondary">{{
            'label.plannedStart' | translate
          }}</sh-text>
          <span>{{ ticket.plannedStart | localizedDate }}</span>
        </div>
        <div class="item">
          <sh-text size="body-2" color="secondary">{{
            'label.plannedEnd' | translate
          }}</sh-text>
          <span style="display: flex; white-space: nowrap"
            >{{ ticket.plannedEnd | localizedDate }}
          </span>
        </div>
        <div class="item">
          <sh-text size="body-2" color="secondary">{{
            'label.ticketNumber' | translate
          }}</sh-text>
          <span style="display: flex; white-space: nowrap"
            >{{ ticket.ticketNumber }}
            <sh-icon
              id="copyToClipboard"
              style="
                cursor: pointer;
                align-items: baseline;
                margin-top: -0.25rem;
                margin-left: 0.5rem;
                display: inline;
              "
              (click)="clipboard.copyToClipboard(ticket.ticketNumber)"
              icon="copy-results-to-clipboard"
              aria-label="Copy results to clipboard"
              button
              size="s"
            ></sh-icon>
          </span>
        </div>
        <div class="item" style="width: 100%">
          <sh-text size="body-2" color="secondary">{{
            'label.typeOfActivity' | translate
          }}</sh-text>
          <span>{{ ticket.ticketType }}</span>
        </div>
        <div class="item">
          <sh-text size="body-2" color="secondary">{{
            'label.TicketstatusLN' | translate
          }}</sh-text>
          <span>{{ ticket.activityStatus }}</span>
        </div>
      </div>
    }
  </div>
</ng-template>
